import { Box, MenuItem, Stack } from '@mui/material';
import { FilterParams } from '@synergy/models';
import { PoolCheckbox, PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';

import { AttributeCounts } from '../../../models/attribute-counts';
import { useFilter } from '../filter-context';

interface FilterAttributeProps {
    initialAttribute: AttributeCounts;
    attributesFromSearch: AttributeCounts[];
    checkedAttributes: AttributeCounts[];
}

export const FilterAttribute = (props: FilterAttributeProps): ReactElement => {
    const { initialAttribute, attributesFromSearch, checkedAttributes } = props;
    const { filter, updateFilter } = useFilter();

    const handleAttributeClick = (attribute: AttributeCounts): void => {
        let attributeKeys = filter.get(FilterParams.AttributeKeys)?.split(',');
        if (attributeKeys?.some(key => key === attribute.key)) {
            attributeKeys = attributeKeys.filter(key => key !== attribute.key);
            if (attributeKeys.length === 0) {
                filter.delete(FilterParams.AttributeKeys);
            } else {
                filter.set(FilterParams.AttributeKeys, attributeKeys.join(','));
            }
        } else {
            filter.set(FilterParams.AttributeKeys, [...(attributeKeys ?? []), attribute.key].join(','));
        }
        updateFilter(filter);
    };

    const isAttributeChecked =
        filter
            .get(FilterParams.AttributeKeys)
            ?.split(',')
            .some(key => key === initialAttribute.key) ?? false;

    const enabled = checkedAttributes.length !== 0;
    const count = enabled
        ? initialAttribute.count
        : attributesFromSearch.find(a => a.key === initialAttribute.key)?.count ?? 0;

    return (
        <MenuItem
            value={initialAttribute.key}
            key={initialAttribute.key}
            disabled={!enabled && count === 0}
            onClick={() => handleAttributeClick(initialAttribute)}
            sx={{ py: 1.5, height: 56, gap: 1.5 }}
        >
            <PoolCheckbox checked={isAttributeChecked} color="dark" disabled={count === 0} sx={{ p: 0 }} />
            <Stack direction="row" sx={{ gap: 0.5, alignItems: 'baseline' }}>
                <Box>{initialAttribute.value}</Box>
                <PoolTypography component="span" typography="caption" color="grey.800">
                    ({count})
                </PoolTypography>
            </Stack>
        </MenuItem>
    );
};
